// 常量定义
import { t } from '@/i18n'

export const VALIDATION_MODES = [
  {
    label: t('Agent → 容器'),
    value: 'agentToContainer',
    help: t('评估验证从agent发起攻击后，对容器资产的安全设备的防护检测情况进行验证评估'),
  },
  {
    label: t('容器Agent → Listener'),
    value: 'containerAgentToListener',
    help: t('评估验证从容器agent发起攻击，至另一个Agent进行验证，评估该路径中安全设备的评估情况'),
  },
]

export const EXECUTION_TYPES = [
  { label: t('立即执行'), value: 'scheduler_type_immediate' },
  { label: t('定时执行'), value: 'scheduler_type_reserve' },
  { label: t('周期执行'), value: 'periodic' },
]

export const FREQUENCY_OPTIONS = [
  { label: t('每天'), value: 'scheduler_type_daily' },
  { label: t('每周'), value: 'scheduler_type_weekly' },
  { label: t('每月'), value: 'scheduler_type_monthly' },
]

export const WEEKLY_OPTIONS = [
  { label: t('星期一'), value: 1 },
  { label: t('星期二'), value: 2 },
  { label: t('星期三'), value: 3 },
  { label: t('星期四'), value: 4 },
  { label: t('星期五'), value: 5 },
  { label: t('星期六'), value: 6 },
  { label: t('星期日'), value: 0 },
]

export const PRIORITY_OPTIONS = [
  { label: t('低'), value: 1 },
  { label: t('中'), value: 5 },
  { label: t('高'), value: 10 },
]
